import { FundraiserCard } from 'components'
import { AppLayout } from 'layouts'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import FormCard from './FormCard'
import FundraiserComplete from './FundraiserComplete'

export function GetStarted({ appState, fundraiser, onFinish, products }) {
  const initialValues = {
    first_name: appState.first_name,
    last_name: appState.last_name,
    roster_idx: appState.roster_idx,
  }

  // Prevent additional orders if the end date has passed and there are
  // no digital products.
  const fundraiserFinished = React.useMemo(
    () =>
      moment() >= moment(fundraiser.end_time) &&
      products.filter((p) => p.is_digital).length === 0,
    [fundraiser, products]
  )

  return (
    <AppLayout>
      <Container>
        <Row className="">
          <Col md={12} lg={6} className="mb-4 mb-lg-0">
            <FundraiserCard fundraiser={fundraiser}>
              <p>{fundraiser.description}</p>
            </FundraiserCard>
          </Col>
          <Col>
            {fundraiserFinished ? (
              <FundraiserComplete />
            ) : (
              <FormCard
                fundraiser={fundraiser}
                onSubmit={onFinish}
                initial={initialValues}
              />
            )}
          </Col>
        </Row>
      </Container>
    </AppLayout>
  )
}

GetStarted.propTypes = {
  appState: PropTypes.object.isRequired,
  fundraiser: PropTypes.object.isRequired,
  onFinish: PropTypes.func.isRequired,
  products: PropTypes.array.isRequired,
}

const mapState = (state) => ({
  appState: state.app,
  fundraiser: state.fundraiser,
  products: state.products,
})

export default connect(mapState)(GetStarted)
